import {
  Box,
  Paper,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell as MuiTableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Grid,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import achievementsData from "../../utils/achievements.json";
import { useEffect, useState } from "react";
import Carousels from "../../components/Carousels";
import { homeImages } from "../Home";

import img1 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0002.jpg";
import img2 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0003.jpg";
import img3 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0005.jpg";
import img4 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0007.jpg";
import img5 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0009.jpg";
import img6 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0020.jpg";
import img7 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0012.jpg";
import img8 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0013.jpg";
import img9 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0014.jpg";
import img10 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0015.jpg";
import img11 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0016.jpg";
import img12 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0017.jpg";
import img13 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0018.jpg";
import img14 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0019.jpg";
import img15 from "../../assets/images/student_corner/StudentsAwardandAchievements/IMG-20251212-WA0020.jpg";
import HorizontalImageScroller from "../../components/HorizontalImageScroller";

const allImages = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15];

type Years = Array<DataItem>;

type DataItem = {
  year: string;
};

type AchievmentObject = {
  name: string;
  course: string;
  rank?: string;
  activity?: string;
  percentage?: String;
  award?: String;
};

const TableCell = styled(MuiTableCell)(({ theme }) => ({
  fontSize: 16,
  color: "currentcolor",
  lineHeight: "22px !important",
}));

const years: Years = [
  { year: "2025" },
  { year: "2024" },
  { year: "2023" },
  { year: "2022" },
  { year: "2021" },
  { year: "2020" },
  { year: "2019" },
];

const Achievements = () => {
  const [year, setYear] = useState("2025");
  const [academicBpth, setAcademicBpth] = useState<Array<AchievmentObject>>([]);
  const [academicMpth, setAcademicMpth] = useState<Array<AchievmentObject>>([]);
  const [cocurricularBpth, setCocurricularBpth] = useState<
    Array<AchievmentObject>
  >([]);
  const [cocurricularMpth, setCocurricularMpth] = useState<
    Array<AchievmentObject>
  >([]);

  const acadmeicTitles = ["Name", "Course", "Rank", "Percentage"];
  const cocurricularTitles = ["Name", "Course", "Activity", "Award"];

  const YearTabs = () => (
    <Grid container spacing={2}>
      {years?.map((item) => (
        <Grid item key={item?.year} xs="auto" sx={{ my: { sm: 1, md: 4 } }}>
          <Chip
            label={item?.year}
            variant="filled"
            sx={{
              color: item?.year === year ? "secondary.main" : "white",
              backgroundColor:
                item?.year === year ? "transparent" : "secondary.main",
              cursor: "pointer",
              border: "2px solid",
              padding: "8px 16px",
              borderRadius: "16px",
              textTransform: "uppercase",
              fontWeight: "bold",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                opacity: 0.8,
                color: "inherit",
                backgroundColor: "transparent",
                border: "2px solid",
                borderColor: "secondary.main",
                "& .MuiChip-label": {
                  textDecoration: "underline",
                },
              },
              "&:active": {
                transform: "scale(0.95)",
              },
            }}
            onClick={() => setYear(item?.year)}
          />
        </Grid>
      ))}
    </Grid>
  );

  useEffect(() => {
    const dataObj = achievementsData?.find((obj) => obj.year === year);

    dataObj?.academic?.bpth && setAcademicBpth([
      ...dataObj?.academic?.bpth,
      {
        name: "Arnavi Mohite",
        course: "1st Year BPTh",
        rank: "1st",
        percentage: "77%",
      },
      {
        name: "Aditi Patil",
        course: "1st Year BPTh",
        rank: "2nd",
        percentage: "74%",
      },
      {
        name: "Gauri Chavan",
        course: "2nd Year BPTh",
        rank: "1st",
        percentage: "74%",
      },
      {
        name: "Sanjana Keskar",
        course: "2nd Year BPTh",
        rank: "2nd",
        percentage: "72%",
      },
      {
        name: "Prachi Kundalkar",
        course: "2nd Year BPTh",
        rank: "3rd",
        percentage: "67.14%",
      },
      {
        name: "Shefali Waldia",
        course: "3rd Year BPTh",
        rank: "1st",
        percentage: "74.20%",
      },
      {
        name: "Sakshi Bibavanekar",
        course: "3rd Year BPTh",
        rank: "2nd",
        percentage: "73.80%",
      },
      {
        name: "Megha Sable",
        course: "3rd Year BPTh",
        rank: "3rd",
        percentage: "72.20%",
      },
      {
        name: "Soham Darekar",
        course: "4th Year BPTh",
        rank: "1st",
        percentage: "64.75%",
      },
      {
        name: "Dhanashri Waskar",
        course: "4th Year BPTh",
        rank: "2nd",
        percentage: "64.25%",
      },
      {
        name: "Madhumalti Bairagi",
        course: "4th Year BPTh",
        rank: "3rd",
        percentage: "62.62%",
      },
    ]);
    dataObj?.academic?.mpth && setAcademicMpth([
      ...dataObj?.academic?.mpth,
      {
        name: "Manik Agashe",
        course: "Final M.P.Th",
        rank: "1st",
        percentage: "74%",
      },
      {
        name: "Priyanka Rathod",
        course: "Final M.P.Th",
        rank: "2nd",
        percentage: "69%",
      },
    ]);

    dataObj?.cocurricular?.bpth &&
      setCocurricularBpth([
        ...dataObj?.cocurricular?.bpth,
        {
          name: "Radhika Gothkhindikar",
          course: "Final yr BPTh",
          activity: "Senior women district weightlifting 2024",
          award: "Gold medal",
        },
        {
          name: "Radhika Gothkhindikar",
          course: "Final yr BPTh",
          activity: "District level selection trials for senior women weightlifting 2024",
          award: "Gold medal",
        },
        {
          name: "Radhika Gothkhindikar",
          course: "Final yr BPTh",
          activity: "Selected for Maharashtra state weightlifting championship",
          award: "Selected",
        },
        {
          name: "Radhika Gothkhindikar",
          course: "Final yr BPTh",
          activity: "State weightlifting championship",
          award: "Best district performance",
        },
        {
          name: "Radhika Gothkhindikar",
          course: "Final yr BPTh",
          activity: "Senior women’s State weightlifting championship",
          award: "Bronze medal",
        },
        {
          name: "Elmer, Digvijay, Rutuparna, Anay, Yash, Suyog, Samarth, Prathamesh, Aditya, Neville",
          course: "Boys football team",
          activity: "Final Football match of the SHAURYA tournament hosted by Dhole Patil College of Physiotherapy 2024",
          award: "Winners",
        },
      ]);
    dataObj?.cocurricular?.mpth &&
      setCocurricularMpth(dataObj?.cocurricular?.mpth);
  }, [year]);

  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 }, display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <YearTabs />
        </Box>
        {/* 2025 – Image only view */}
        {year === "2025" && (
          <Accordion defaultExpanded sx={{ width: "100%" }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                variant="h5"
                sx={{ my: 3, fontWeight: "bold", color: "primary.main" }}
              >
                Students Achievements – 2025
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <HorizontalImageScroller images={allImages} />
            </AccordionDetails>
          </Accordion>
        )}



        {["academic", "cocurricular"].map((val) => {
          const isAcademic = val === "academic";
          const titleVariable =
            val === "academic" ? "Academic" : "Co-curricular";

          const titlesList =
            val === "academic" ? acadmeicTitles : cocurricularTitles;

          const bptTableData =
            val === "academic" ? academicBpth : cocurricularBpth;
          const mptTableData =
            val === "academic" ? academicMpth : cocurricularMpth;
          return (
            <Accordion key={val} defaultExpanded sx={{ width: "100%" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2-content"
                id="panel2-header"
              >
                <Typography
                  variant="h5"
                  align="center"
                  sx={{ my: 3, fontWeight: "bold", color: "primary.main" }}
                >
                  {`Students ${titleVariable} Achievements`}
                </Typography>
              </AccordionSummary>

              {/* Bpt */}
              <Box>
                <AccordionDetails>
                  <Typography
                    sx={{ my: 1, color: "primary.main", fontWeight: "bold" }}
                  >
                    {`BPTh - ${year}`}{" "}
                  </Typography>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead
                        sx={{
                          backgroundColor: "primary.main",
                          color: "text.primary",
                        }}
                      >
                        <TableRow sx={{ color: "#fff" }}>
                          {titlesList.map((title, i) => (
                            <TableCell key={i} sx={{ border: 1 }}>
                              {title}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody sx={{ color: "#000" }}>
                        {bptTableData?.length > 0 ? (
                          bptTableData.map((elem, rowIndex) => {
                            return (
                              <TableRow key={rowIndex}>
                                <TableCell
                                  sx={{ color: "secondary.main", border: 1 }}
                                >
                                  {elem["name"]}
                                </TableCell>
                                <TableCell
                                  sx={{ color: "secondary.main", border: 1 }}
                                >
                                  {elem["course"]}
                                </TableCell>
                                {isAcademic ? (
                                  <>
                                    <TableCell
                                      sx={{
                                        color: "secondary.main",
                                        border: 1,
                                      }}
                                    >
                                      {elem["rank"]}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        color: "secondary.main",
                                        border: 1,
                                      }}
                                    >
                                      {elem["percentage"] as string}
                                    </TableCell>
                                  </>
                                ) : (
                                  <>
                                    <TableCell
                                      sx={{
                                        color: "secondary.main",
                                        border: 1,
                                      }}
                                    >
                                      {elem["activity"]}
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        color: "secondary.main",
                                        border: 1,
                                      }}
                                    >
                                      {elem["award"] as string}
                                    </TableCell>
                                  </>
                                )}
                              </TableRow>
                            );
                          })
                        ) : (
                          <TableRow>
                            <TableCell
                              colSpan={titlesList.length}
                              sx={{ textAlign: "center" }}
                            >
                              No Data
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </AccordionDetails>
              </Box>
              <Divider
                sx={{
                  my: 1,
                  color: "primary",
                  width: "100%",
                  borderTop: "1px solid",
                }}
              />
              {/* Mpt */}
              {val === "academic" && (
                <Box>
                  <AccordionDetails>
                    <Typography
                      sx={{ my: 1, color: "primary.main", fontWeight: "bold" }}
                    >
                      {`MPTh - ${year}`}{" "}
                    </Typography>
                    <TableContainer component={Paper}>
                      <Table>
                        <TableHead
                          sx={{
                            backgroundColor: "primary.main",
                            color: "text.primary",
                          }}
                        >
                          <TableRow sx={{ color: "#fff" }}>
                            {titlesList.map((title, i) => (
                              <TableCell key={i} sx={{ border: 1 }}>
                                {title}
                              </TableCell>
                            ))}
                          </TableRow>
                        </TableHead>
                        <TableBody sx={{ color: "#000" }}>
                          {mptTableData?.length > 0 ? (
                            mptTableData.map((elem, rowIndex) => {
                              return (
                                <TableRow key={rowIndex}>
                                  <TableCell
                                    sx={{ color: "secondary.main", border: 1 }}
                                  >
                                    {elem["name"]}
                                  </TableCell>
                                  <TableCell
                                    sx={{ color: "secondary.main", border: 1 }}
                                  >
                                    {elem["course"]}
                                  </TableCell>
                                  <TableCell
                                    sx={{ color: "secondary.main", border: 1 }}
                                  >
                                    {elem["rank"]}
                                  </TableCell>
                                  <TableCell
                                    sx={{ color: "secondary.main", border: 1 }}
                                  >
                                    {elem["percentage"] as string}
                                  </TableCell>
                                </TableRow>
                              );
                            })
                          ) : (
                            <TableRow>
                              <TableCell
                                colSpan={titlesList.length}
                                sx={{ textAlign: "center" }}
                              >
                                No Data
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </AccordionDetails>
                </Box>
              )}
            </Accordion>
          );
        })}
      </Stack>
    </Box>
  );
};

export default Achievements;
